import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const tradeContractRouters: RouteRecordRaw[] = [
    {
        path: "tradeContract",
        name: "TradeContract",
        meta: {
            title: "合同管理",
            activeMenu: "TradeContract",
            pageType: PAGE_TYPE.LIST.code,
            keepAlive: true
        },
        component: () => import("@/views/pages/tradeManagement/contractManagement/index.vue")
    },
    {
        path: "tradeContract/tradeContractDetail",
        name: "TradeContractDetail",
        meta: { title: "合同详情", hidden: true, activeMenu: "TradeContract" },
        component: () => import("@/views/pages/tradeManagement/contractManagement/detail.vue")
    },
    {
        path: "tradeContract/tradeContractAdd",
        name: "TradeContractAdd",
        meta: { title: "新增合同", hidden: true, activeMenu: "TradeContract" },
        component: () => import("@/views/pages/tradeManagement/contractManagement/form.vue")
    },
    {
        path: "tradeContract/tradeContractEdit",
        name: "TradeContractEdit",
        meta: { title: "修改合同", hidden: true, activeMenu: "TradeContract" },
        component: () => import("@/views/pages/tradeManagement/contractManagement/form.vue")
    }
];

export default tradeContractRouters;
